import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_CriticalIncidentReportForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ROC_CriticalIncidentReportForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h4>CRITICAL INCIDENT REPORT FORM</h4></center></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>CLIENT:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClient' name='txtClient' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>INCIDENT:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Time:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtIncident' name='txtIncident' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='time' id='txtTime' name='txtTime' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Involved:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Location:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientInvolved' name='txtClientInvolved' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtLocation' name='txtLocation' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Employee</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Title/Position:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEmployee' name='txtEmployee' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTitlePosition' name='txtTitlePosition' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Supervisor:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Title/Position:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupervisor' name='txtSupervisor' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTitlePosition_1' name='txtTitlePosition_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Witness(es)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWitness' name='txtWitness' className='add-only' /></td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>TYPE OF INCIDENT:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_1' name='rbTypeOfIncident' className='add-only' value='1' /> Accident/Injury</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_2' name='rbTypeOfIncident' className='add-only' value='2' /> Accusation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_3' name='rbTypeOfIncident' className='add-only' value='3' /> Vehicle accident</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_4' name='rbTypeOfIncident' className='add-only' value='4' /> Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_5' name='rbTypeOfIncident' className='add-only' value='5' /> Neglect</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_6' name='rbTypeOfIncident' className='add-only' value='6' /> Biohazard</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_7' name='rbTypeOfIncident' className='add-only' value='7' /> After “hours” emergency</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_8' name='rbTypeOfIncident' className='add-only' value='8' /> Neglect of Services</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_9' name='rbTypeOfIncident' className='add-only' value='9' /> Property damage</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_10' name='rbTypeOfIncident' className='add-only' value='10' /> Unsafe Circumstance</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_11' name='rbTypeOfIncident' className='add-only' value='11' /> Threat/Intimidation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_12' name='rbTypeOfIncident' className='add-only' value='12' /> Physical Restraint</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_13' name='rbTypeOfIncident' className='add-only' value='13' /> Death of Client</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_14' name='rbTypeOfIncident' className='add-only' value='14' /> Attempted Suicide</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_15' name='rbTypeOfIncident' className='add-only' value='15' /> Attempted Homicide</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_16' name='rbTypeOfIncident' className='add-only' value='16' /> Sexual Assault</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_17' name='rbTypeOfIncident' className='add-only' value='17' /> Mental Health Crisis</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_18' name='rbTypeOfIncident' className='add-only' value='18' /> Drug/Alcohol Overdose</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_19' name='rbTypeOfIncident' className='add-only' value='19' /> Possession/Use of Weapon(s)</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfIncident_20' name='rbTypeOfIncident' className='add-only' value='20' /> Elopement/Wandering</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_21' name='rbTypeOfIncident' className='add-only' value='21' /> Use/Possession of Illicit Drugs</td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Details:</span>
                    <textarea id='txtDetails' name='txtDetails' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Employee Action/Response:</span>
                    <textarea id='txtEmployeeActionResponse' name='txtEmployeeActionResponse' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Actions (To Be) Taken:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_1' name='rbActionsToBeTaken' className='add-only' value='1' /> Report made to Children's Protective Services (Ref. #)&nbsp;
                            <input type='text' id='txtReportMadeToChild' name='txtReportMadeToChild' className='add-only w-370 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_2' name='rbActionsToBeTaken' className='add-only' value='2' /> Report made to supervisor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_3' name='rbActionsToBeTaken' className='add-only' value='3' /> Report made to Adult Protective Services
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_4' name='rbActionsToBeTaken' className='add-only' value='4' /> Report made to Police
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_5' name='rbActionsToBeTaken' className='add-only' value='5' /> Close/Discharge Client
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_6' name='rbActionsToBeTaken' className='add-only' value='6' /> Report made to housing manager
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_7' name='rbActionsToBeTaken' className='add-only' value='7' /> Follow-up &nbsp;
                            <input type='text' id='txtFollowUp' name='txtFollowUp' className='add-only w-650 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbActionsToBeTaken_8' name='rbActionsToBeTaken' className='add-only' value='8' /> Other &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-650 custom-add-only' />
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Employee Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Supervisor Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                </table>































            </div >
        </form >

    )
}











